import React from 'react';
import ReactMarkdown from 'react-markdown';

const ContentSection = ({ sections, language }) => {
  const speakText = (text) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = language === 'es' ? 'es-ES' : 'en-US';
      speechSynthesis.cancel();
      speechSynthesis.speak(utterance);
    } else {
      alert('Tu navegador no soporta la síntesis de voz.');
    }
  };

  const cleanMarkdownText = (text) => {
    return text.replace(/[_*`-]/g, '').trim();
  };

  if (!Array.isArray(sections) || sections.length === 0) {
    return <p className="text-center text-gray-500">No hay contenido disponible.</p>;
  }

  // Componente personalizado para renderizar imágenes y enlaces
  const markdownComponents = {
    img: ({ node, ...props }) => (
      <img
        {...props}
        style={{
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: '70%',
          height: 'auto'
        }}
        alt={props.alt || ''}
      />
    ),
    a: ({ node, ...props }) => (
      <a
        {...props}
        target="_blank"
        rel="noopener noreferrer" // Es importante agregar "rel" por seguridad
        style={{ color: '#1a73e8', textDecoration: 'underline' }}
      >
        {props.children}
      </a>
    )
  };

  return (
    <div style={{ width: '90%', margin: '0 auto', padding: '2rem' }}>
      {sections.map((section, index) => (
        <div key={index} id={`topic-${section.id || index}`} style={{ marginBottom: '3rem' }}>
          {section.subtitle && (
            <h4
              style={{
                fontSize: '2rem',
                fontWeight: '600',
                color: '#000',
                textAlign: 'left',
                marginBottom: '1rem'
              }}
            >
              {section.subtitle}
            </h4>
          )}

          {section.content && section.content.length > 0 && (
            <div
              style={{
                color: '#4a5568',
                textAlign: 'justify',
                lineHeight: '1.8',
                fontSize: '1.5rem'
              }}
            >
              {section.content.map((paragraph, idx) => (
                <div key={idx} style={{ marginBottom: '15px' }}>
                  <ReactMarkdown components={markdownComponents}>
                    {paragraph}
                  </ReactMarkdown>
                </div>
              ))}
            </div>
          )}

          {section.tables && section.tables.length > 0 && (
            <div>
              {section.tables.map((table, tableIndex) => {
                const headers = table[0].split('|').map(h => cleanMarkdownText(h));
                const rows = table.slice(1).map(row => row.split('|').map(cell => cleanMarkdownText(cell)));

                return (
                  <div
                    key={tableIndex}
                    style={{
                      marginBottom: '2rem',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      border: '1px solid #ddd'
                    }}
                  >
                    <table
                      style={{
                        width: '100%',
                        fontSize: '1.125rem',
                        borderCollapse: 'collapse'
                      }}
                    >
                      <thead style={{ backgroundColor: '#f5f5f5', color: '#333' }}>
                        <tr>
                          {headers.map((header, idx) => (
                            <th
                              key={idx}
                              style={{
                                padding: '12px 16px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                border: '1px solid #ccc'
                              }}
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, rowIndex) => (
                          <tr
                            key={rowIndex}
                            style={{
                              backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#eeeeee'
                            }}
                          >
                            {row.map((cell, cellIndex) => (
                              <td
                                key={cellIndex}
                                style={{
                                  padding: '12px 16px',
                                  textAlign: 'center',
                                  border: '1px solid #ddd'
                                }}
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ContentSection;
